module.exports = __webpack_public_path__ + "img/qrcodea.67e00f87.png";